<template>
  <li
    :class="[
      'border-line border-b last-of-type:border-none md:border-none md:rounded-lg transition-[border-radius_border]',
      `bg-${background}`,
    ]"
  >
    <div
      class="flex justify-between items-center gap-7 p-5 md:p-8 transition-[padding] select-none cursor-pointer"
      @click.stop="toggle"
    >
      <h3 class="font-semibold text-xl md:text-2xl">{{ title }}</h3>
      <button
        class="relative flex items-center justify-center w-7 h-7 shrink-0 pointer-events-none"
      >
        <span :class="[button_span_classes, { '-rotate-180': opened }]"></span>
        <span :class="[button_span_classes, { 'rotate-90': !opened }]"></span>
      </button>
    </div>
    <div
      :class="[
        'grid grid-rows-[0fr] transition-[grid-template-rows]',
        { 'grid-rows-[1fr]': opened },
      ]"
    >
      <div class="overflow-hidden">
        <div
          :class="[
            'px-5 md:px-8 pb-8 md:pb-10 transition-[padding_opacity] opacity-0',
            { 'opacity-100': opened },
          ]"
        >
          <RawHtml :html="content" />
          <OptionalButtons :buttons="buttons" class="mt-6 md:mt-8" />
        </div>
      </div>
    </div>
  </li>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { RawHtml } from "@/components/helpers";
import { OptionalButtons } from "@/components/blocks";

export default {
  name: "DropdownCard",
  components: { OptionalButtons, RawHtml },
  setup() {
    return {
      button_span_classes: "w-7 h-0.5 bg-(--main-color) block absolute transition-[rotate]",
    };
  },
  props: {
    background: {
      type: String as PropType<background>,
      required: true,
    },
    buttons: {
      type: Array as PropType<Link[]>,
      default: [],
    },
    content: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      opened: false as boolean,
    };
  },
  methods: {
    toggle() {
      this.opened = !this.opened;
    },
  },
};
</script>
